<template>
  <div class="">
    <div class="tab__header flex flex-col md:flex-row justify-between items-start md:items-center">
      <a
        href="#"
        class="tab__link no-underline"
        @click.prevent="toggleItem"
      >
        <div class="flex items-center justify-between p-4">
          <div class="flex items-center">
            <div v-show="!active" class="mr-4">
              <img :src="require('@assets/images/ic-expand.svg')" alt="Expand" />
            </div>
            <div v-show="active" class="mr-4">
              <img :src="require('@assets/images/ic-collapse.svg')" alt="Expand" />
            </div>
            <div class="menu-item-title">{{ title }}</div>
          </div>
        </div>
      </a>
      <slot name="accordion-header" />
    </div>
    <div v-show="active" class="tab__content bg-white">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      active: this.show,
    };
  },
  methods: {
    toggleItem() {
      this.active = !this.active;

      let push = {
        is_open: this.active,
        category: this.title,
      };
      this.$sendEvent('RS_category', push);
    },
  },
};
</script>

<style>
  @media (max-width: 992px) {
    .resto-menu {
      width: 93%;
    }
    .menu-item-title {
      max-width: 992px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
</style>
